import React, { useEffect, useRef, useState } from 'react'
import { DoorbellType, FieldTypes } from '../../utils/constants'
import Form from '../common/Form'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'

export default function DoorbellForm({
  buildingId,
  onSubmit,
  handleCancel,
  doorbell,
  isGate,
  doorbellGroupsState,
}) {
  const classes = useStyles()
  const [values, setValues] = useState(doorbell || { openDoorEnabled: true })
  const inputRef = useRef()

  useEffect(() => {
    if (isGate) {
      setValues({
        ...values,
        sip: ' ',
        sipPassword: ' ',
        wssURL: ' ',
        remoteAccessKey: ' ',
        rtspURL: values.rtspURL ?? '',
        webrtcURL: values.webrtcURL ?? '',
        webrtcUser: values.webrtcUser ?? '',
        webrtcPassword: values.webrtcPassword ?? '',
      })
    } else {
      setValues({
        ...values,
        idRelay: ' ',
        isEntrance: true,
        webrelayResidents: '0',
        webrelayVisitors: '0',
        webrelayOthers: '0',
        isForPedestrians: true,
      })
    }
  }, [])

  const handleSelectFile = (event) => {
    event.preventDefault()
    var files = event.target.files,
      f = files[0]
    var reader = new FileReader()
    reader.onload = (e) => {
      var data = e.target.result
      setValues({ ...values, image: data, imageUpdated: true })
    }
    reader.readAsDataURL(f)
  }

  return (
    <div className={classes.paper}>
      <ListHeader
        bigTitle={`${doorbell && doorbell.id ? 'Editar' : 'Crear'} ${
          isGate ? 'Porton' : 'portero'
        }`}
        canCreate={false}
      />
      <Form
        values={values}
        setValues={setValues}
        formWidth={classes.formWidth}
        fields={[
          {
            type: FieldTypes.TextField,
            label: 'Nombre',
            hint: 'Ingrese nombre',
            key: 'name',
            errorMessage: 'El nombre es requerido',
            withMargin: true,
          },
          {
            type: FieldTypes.Select,
            id: 'type',
            label: 'Tipo de dispositivo',
            hint: 'Seleccione un tipo de dispositivo',
            key: 'type',
            errorMessage: 'El tipo de dispositivo es requerido',
            withMargin: true,
            renderValue: (value) => (!value ? 'Tipo' : value),
            options: !isGate
              ? Object.keys(DoorbellType)
                  .filter(
                    (key) =>
                      key !== DoorbellType.GATE &&
                      key !== DoorbellType.SURIX_GATE
                  )
                  .map((key) => ({
                    value: key,
                    label: key,
                  }))
              : [
                  {
                    value: DoorbellType.GATE,
                    label: DoorbellType.GATE,
                  },
                  {
                    value: DoorbellType.SURIX_GATE,
                    label: DoorbellType.SURIX_GATE,
                  },
                ],
          },
          {
            type: FieldTypes.TextField,
            label: 'Url RTSP',
            hint: isGate
              ? 'Ingrese la url RTSP (opcional, para video del portón)'
              : 'Ingrese la url RTSP',
            key: 'rtspURL',
            errorMessage: !isGate ? 'La url RTSP es requerida' : undefined,
            withMargin: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Url WebRTC',
            hint: isGate
              ? 'Ingrese la url WebRTC (opcional, para video del portón)'
              : 'Ingrese la url WebRTC (opcional)',
            key: 'webrtcURL',
            withMargin: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Usuario WebRTC',
            hint: 'Ingrese un usuario WebRTC (opcional)',
            key: 'webrtcUser',
            withMargin: true,
          },
          {
            type: FieldTypes.TextField,
            label: 'Contraseña WebRTC',
            hint: 'Ingrese una contraseña WebRTC (opcional)',
            key: 'webrtcPassword',
            fieldType: 'password',
            withMargin: true,
          },
          ...(isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Usuario',
                  hint: 'Ingrese un usuario',
                  key: 'user',
                  errorMessage: 'El usuario es requerido',
                  withMargin: true,
                },
              ]
            : []),
          {
            type: FieldTypes.TextField,
            label: isGate ? 'Url Portón' : 'Url Portero',
            hint: `Ingrese la url ${isGate ? 'Portón' : 'Portero'}`,
            key: 'doorbelURL',
            errorMessage: `La url ${
              isGate ? 'Portón' : 'Portero'
            } es requerida`,
            withMargin: true,
          },
          ...(!isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Sip',
                  hint: 'Ingrese un sip',
                  key: 'sip',
                  errorMessage: 'El sip es requerido',
                  withMargin: true,
                },
              ]
            : []),
          ...(isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Id Relay',
                  hint: 'Ingrese un id relay',
                  key: 'idRelay',
                  errorMessage: 'El id relay es requerido',
                  withMargin: true,
                },
              ]
            : []),
          ...(!isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Contraseña SIP',
                  hint: 'Ingrese una contraseña SIP',
                  key: 'sipPassword',
                  errorMessage: 'La contraseña SIP es requerida',
                  withMargin: true,
                },
              ]
            : []),
          ...(!isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Usuario',
                  hint: 'Ingrese un usuario',
                  key: 'user',
                  errorMessage: 'El usuario es requerido',
                  withMargin: true,
                },
              ]
            : []),
          {
            type: FieldTypes.TextField,
            label: 'Contraseña',
            hint: 'Ingrese una contraseña',
            key: 'password',
            errorMessage: 'La contraseña es requerida',
            withMargin: true,
          },
          ...(!isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Url WSS',
                  hint: 'Ingrese una wrl WSS',
                  key: 'wssURL',
                  errorMessage: 'La wrl WSS es requerida',
                  withMargin: true,
                },
              ]
            : []),
          ...(!isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Clave de acceso remoto',
                  hint: 'Ingrese una clave de acceso remoto',
                  key: 'remoteAccessKey',
                  errorMessage: 'La clave de acceso remoto es requerida',
                  withMargin: true,
                },
              ]
            : []),
          ...(!isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Webrelay residentes',
                  hint: 'Ingrese un webrelay residentes',
                  key: 'webrelayResidents',
                  errorMessage: 'El webrelay residentes es requerido',
                  withMargin: true,
                },
              ]
            : []),
          ...(!isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Webrelay visitantes',
                  hint: 'Ingrese un webrelay visitantes',
                  key: 'webrelayVisitors',
                  errorMessage: 'El webrelay visitantes es requerido',
                  withMargin: true,
                },
              ]
            : []),
          ...(!isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Webrelay otros',
                  hint: 'Ingrese un webrelay otros',
                  key: 'webrelayOthers',
                  errorMessage: 'El webrelay otros es requerido',
                  withMargin: true,
                },
              ]
            : []),
          ...(!isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Descripción',
                  hint: 'Ingrese una descripción',
                  key: 'description',
                  errorMessage: 'La descripción es requerida',
                  withMargin: true,
                },
              ]
            : []),
          {
            type: FieldTypes.Select,
            id: 'isEntrance',
            label: 'Tipo de dispositivo',
            hint: 'Seleccione un tipo de dispositivo',
            key: 'isEntrance',
            withMargin: true,
            renderValue: () => {
              if (values.isEntrance === true) {
                return 'Ingreso'
              } else if (values.isEntrance === false) {
                return 'Egreso'
              } else {
                return 'Egreso/Ingreso'
              }
            },
            options: [
              {
                value: null,
                label: 'Egreso/Ingreso',
              },
              {
                value: true,
                label: 'Ingreso',
              },
              {
                value: false,
                label: 'Egreso',
              },
            ],
          },
          ...(isGate
            ? [
                {
                  type: FieldTypes.TextField,
                  label: 'Descripcion',
                  hint: 'Ingrese una descripción',
                  key: 'description',
                  errorMessage: 'La descripción es requerida',
                  withMargin: true,
                },
              ]
            : []),
          ...(isGate
            ? [
                {
                  type: FieldTypes.Autocomplete,
                  label: 'Grupos de portones',
                  hint: 'Asigne un grupo de portones',
                  key: 'apartments',
                  options: doorbellGroupsState?.doorbellGroups || [],
                  multiple: false,
                  freeSolo: true,
                  withMargin: true,
                  loading: doorbellGroupsState.isLoading,
                  onInputChange: (event, newInputValue) => {
                    setValues({
                      ...values,
                      group: { buildingId, name: newInputValue },
                    })
                  },
                  onChange: (evt, value) => {
                    if (value) {
                      setValues({ ...values, group: value })
                    }
                  },
                },
              ]
            : []),
          {
            type: FieldTypes.Select,
            id: 'openDoorRelay',
            label: 'Open Door Relay',
            hint: 'Seleccione el relay para abrir puerta',
            key: 'openDoorRelay',
            errorMessage: 'El relay es requerido',
            withMargin: true,
            renderValue: (value) => (!value ? 'Seleccione relay' : value),
            options: [
              {
                value: 1,
                label: '1',
              },
              {
                value: 2,
                label: '2',
              },
              {
                value: 3,
                label: '3',
              },
            ],
          },
          {
            type: FieldTypes.UploadImage,
            label: 'Subir Imagen',
            onChange: (event) => handleSelectFile(event),
            selectedFile: values.image,
            inputRef: inputRef,
            withMargin: true,
          },
          ...(!isGate
            ? [
                {
                  type: FieldTypes.DoubleCheckbox,
                  withMargin: true,
                  checkboxes: [
                    {
                      checked: values.isForPedestrians,
                      onChange: (evt) => {
                        setValues({
                          ...values,
                          isForPedestrians: !values.isForPedestrians,
                        })
                      },
                      label: 'Acceso peatonal',
                    },
                    {
                      checked: values.portraitFormat,
                      onChange: (evt) => {
                        setValues({
                          ...values,
                          portraitFormat: !values.portraitFormat,
                        })
                      },
                      label: 'Formato video vertical',
                    },
                  ],
                },
              ]
            : []),
          {
            type: FieldTypes.Switch,
            label: 'Abrir puerta habilitado',
            key: 'openDoorEnabled',
          },
        ]}
        handleSubmit={onSubmit}
        handleCancel={handleCancel}
      />
    </div>
  )
}
